function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M15.5024 10.7826C15.824 9.91594 16 8.97856 16 8C16 7.02144 15.824 6.08406 15.5024 5.21741H0.497594C0.176031 6.08406 0 7.02144 0 8C0 8.97856 0.176031 9.91594 0.497594 10.7826L8 11.4783L15.5024 10.7826Z",
  fill: "#0052B4"
}), React.createElement("path", {
  d: "M7.99996 16C11.4397 16 14.372 13.829 15.5024 10.7826H0.497559C1.6279 13.829 4.56025 16 7.99996 16Z",
  fill: "#D80027"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
const SvgRussia = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgRussia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/russia.814a9ebb.svg";
export { ForwardRef as ReactComponent };